/**
 * Client-side cart cache for the header cart (rp:cart:v1).
 *
 * TODO: Remove this file (wrapper). cart.js should use localstorage-slim directly and cache-config.js for TTL.
 *
 * IMPORTANT:
 * TTL is handled by localstorage-slim through the local-storage wrapper.
 * This module uses the existing storage helpers to avoid code duplication.
 */

import { getItem, setItem, removeItem } from 'public/js/lib/local-storage';

export const CART_CACHE_KEY = 'rp:cart:v1';

/**
 * Get cached cart data.
 *
 * @param {string} [key=CART_CACHE_KEY] Cache key (for tests)
 * @returns {Object|null} Cached cart data or null
 */
export function getCachedCart(key = CART_CACHE_KEY) {
	const cached = getItem(key);
	return cached || null;
}

/**
 * Set cached cart data with TTL handled by localstorage-slim.
 *
 * @param {Object} cartData Cart data to cache
 * @param {string} [key=CART_CACHE_KEY] Cache key (for tests)
 * @param {number} [ttlSeconds] TTL in seconds (for tests)
 */
export function setCachedCart(cartData, key = CART_CACHE_KEY, ttlSeconds = undefined) {
	if (cartData === null || cartData === undefined) {
		return;
	}

	const ttl = ttlSeconds !== undefined && ttlSeconds !== null ? ttlSeconds : rp_app.cacheConfig.getTtlFor('cart');
	setItem(key, cartData, { ttl });
}

/**
 * Clear cached cart data.
 *
 * @param {string} [key=CART_CACHE_KEY] Cache key (for tests)
 */
export function clearCachedCart(key = CART_CACHE_KEY) {
	removeItem(key);
}
